import { ConcreteEncodable } from "./ConcreteEncodable";

import { ClientTraderUpdateRequestImplEncoder } from "../../encoder/ClientTraderUpdateRequestImplEncoder";

import * as CubiqTS from "../../index";
import { ClientTraderUpdateRequest } from "../ClientTraderUpdateRequest";

export class ClientTraderUpdateRequestImpl
  extends ConcreteEncodable
  implements ClientTraderUpdateRequest
{
  public static enType: string = "com.bcdfx.model.event.ClientTraderUpdateRequestImpl";

  /*FID=1*/
  public clientCode: string;
  /*FID=2*/
  public userName: string;
  /*FID=3*/
  public desk: string;
  /*FID=4*/
  public mobile: string;
  /*FID=5*/
  public email: string;
  /*FID=6*/
  public isDefault: boolean;
  /*FID=7*/
  public comment: string;
  /*FID=8*/
  public userCode: string;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ClientTraderUpdateRequestImplEncoder.Instance;
    this.setEncodableType(ClientTraderUpdateRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "ClientTraderUpdateRequestImpl[" +
      "clientCode=" +
      this.clientCode +
      "userName=" +
      this.userName +
      "desk=" +
      this.desk +
      "mobile=" +
      this.mobile +
      "email=" +
      this.email +
      "isDefault=" +
      this.isDefault +
      "comment=" +
      this.comment +
      "userCode=" +
      this.userCode +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
